import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import toast, { Toaster } from 'react-hot-toast';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/system';
import axios from '../../../../axios';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { DialogActions, Grid, IconButton, MenuItem, TextField, Typography } from '@mui/material';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import UpdatePackageItem from './UpdatePackageItem';
import { ImageUpload } from '../../../components/DropZone/ImageUpload';
import createNFTUpload from '../../../../assets/createNFTUpload.png';
import { baseImageUrl } from '../../../utils/config';
import { UPDATE_PACKAGE } from '../../../api';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ImageRoundedIcon from '@mui/icons-material/ImageRounded';

function UpdatePackageModal({
  open,
  handleClosePackage,
  serviceData,
  retrieveService,
  selectedPackageData,
}) {
  const [loading, setLoading] = useState(false);
  const [UpdateItemModal, setUpdateItemModal] = useState(false);
  const [packageData, setPackageData] = useState({});
  const fetchAndCreateFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const fileName = url.substring(url.lastIndexOf('/') + 1);
    return new File([blob], fileName, { type: blob.type });
  };
  const schema = Yup.object().shape({
    title: Yup.string().required('Title is required'),
    front_end_field_type: Yup.string().required('Front end field type is required!'),
  });
  const formik = useFormik({
    initialValues: {
      title: '',
      front_end_field_type: '',
      service: '',
      id: '',
      order: '',
      image_12pack: '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      setLoading(true);
      const formData = new FormData();
      let file1;
      if (typeof values.image_12pack === 'string') {
        try {
          const fileImg1 = await fetchAndCreateFile(values?.image_12pack);
          file1 = fileImg1;
        } catch (error) {
          console.error('Error occurred while downloading files:', error);
        }
      } else {
        file1 = values.image_12pack;
      }

      formData.append('title', values?.title);
      formData.append('id', values.id);
      formData.append('order', values.order);
      formData.append('front_end_field_type', values?.front_end_field_type);
      formData.append('service', values?.service);
      if (file1) {
        formData.append('image_12pack', file1);
      }
      toast.promise(
        axios.put(`${UPDATE_PACKAGE}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        }),
        {
          loading: () => {
            return `Updating Package!`;
          },
          success: (res) => {
            setPackageData(res?.data?.data);
            setLoading(false);
            resetForm();
            setUpdateItemModal(true);

            setTimeout(() => {
              handleClosePackage();
              retrieveService();
            }, 200);

            return res?.data?.message;
          },
          error: (err) => {
            setLoading(false);
            return err?.message;
          },
        }
      );
    },
  });

  const { errors, touched, resetForm, setFieldValue, handleSubmit, getFieldProps, values } = formik;
  useEffect(() => {
    if (selectedPackageData && open) {
      setFieldValue('service', serviceData?.id);
      setFieldValue('id', selectedPackageData?.id);
      setFieldValue('order', selectedPackageData?.order);
      setFieldValue('title', selectedPackageData?.title);
      setFieldValue('front_end_field_type', selectedPackageData?.front_end_field_type);
      setFieldValue('image_12pack', baseImageUrl + selectedPackageData?.image_12pack);
    }
  }, [open, selectedPackageData, serviceData, setFieldValue]);
  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          handleClosePackage();
          resetForm();
        }}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { height: 'min(720px, calc(100vh - 40px))', display: 'flex', flexDirection: 'column', borderRadius: 3.5, overflow: 'hidden', boxShadow: '0 26px 80px rgba(15,35,70,.24)' } }}
        aria-labelledby="package-item"
        aria-describedby="package-item-description"
      >
        <DialogTitle id="package-item" sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 1.4, bgcolor: '#f8fbff', borderBottom: '1px solid #e5edf6' }}>
          <Box sx={{ width: 42, height: 42, display: 'grid', placeItems: 'center', borderRadius: 2.5, bgcolor: '#e7f2ff', color: '#1976d2' }}><Inventory2OutlinedIcon /></Box>
          <Box sx={{ flex: 1, minWidth: 0 }}><Typography noWrap sx={{ color: '#10224a', fontSize: 19, fontWeight: 850 }}>Update Package</Typography><Typography noWrap sx={{ mt: .2, color: '#718096', fontSize: 11 }}>{selectedPackageData?.title || 'Edit package details and continue to its items.'}</Typography></Box>
          <IconButton size="small" aria-label="Close" onClick={() => { handleClosePackage(); resetForm(); }}><CloseRoundedIcon /></IconButton>
        </DialogTitle>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit} style={{ display: 'flex', flex: 1, minHeight: 0, flexDirection: 'column', overflow: 'hidden' }}>
            <DialogContent sx={{ flex: 1, minHeight: 0, overflowY: 'auto', px: 3, py: '24px !important' }}>
              <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    type="text"
                    label="Title"
                    {...getFieldProps('title')}
                    error={Boolean(touched.title && errors.title)}
                    helperText={touched.title && errors.title}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />
                </Grid>
                <Grid item sm={6} xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    type="text"
                    label="Front end field type*"
                    select
                    {...getFieldProps('front_end_field_type')}
                    error={Boolean(touched.front_end_field_type && errors.front_end_field_type)}
                    helperText={touched.front_end_field_type && errors.front_end_field_type}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  >
                    <MenuItem value={'select'}>Selection</MenuItem>
                    <MenuItem value={'card'}>Card</MenuItem>
                  </TextField>
                </Grid>
                <Grid item sm={12} xs={12}>
                  <TextField
                    size="small"
                    fullWidth
                    type="number"
                    label="Order"
                    {...getFieldProps('order')}
                    error={Boolean(touched.order && errors.order)}
                    helperText={touched.order && errors.order}
                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ p: 1.5, border: '1px solid #dce6f1', borderRadius: 2.5, bgcolor: '#fbfdff' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><Box sx={{ width: 32, height: 32, display: 'grid', placeItems: 'center', borderRadius: 1.7, bgcolor: '#edf5ff', color: '#1976d2' }}><ImageRoundedIcon fontSize="small" /></Box><Box><Typography sx={{ color: '#183153', fontSize: 12, fontWeight: 800 }}>Package Image</Typography><Typography sx={{ color: '#718096', fontSize: 10 }}>Supported image formats, maximum size 5 MB.</Typography></Box></Box>
                  <ImageUpload
                    name="image_12pack"
                    Isvideo={false}
                    inputProps={{ accept: 'image/*' }}
                    src={values?.image_12pack || createNFTUpload}
                    buttonProps={{
                      className: '!flex !justify-start !p-0 !py-4',
                    }}
                    onChange={(e, file) => {
                      setFieldValue(e, file);
                    }}
                    error={touched.profile_picture && Boolean(errors.profile_picture)}
                    helperText={touched.profile_picture && errors.profile_picture}
                  />
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ flexShrink: 0, px: 3, py: 1.8, borderTop: '1px solid #e5edf6', bgcolor: '#fbfdff' }}>
                <Button
                  onClick={() => {
                    handleClosePackage();
                    resetForm();
                  }}
                  variant="outlined"
                  color="inherit"
                  sx={{ minWidth: 94, borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
                >
                  Cancel
                </Button>
                <LoadingButton
                  type="submit"
                  color="primary"
                  startIcon={<KeyboardArrowRightIcon />}
                  loading={loading}
                  variant="contained"
                  sx={{ minWidth: 126, borderRadius: 2, textTransform: 'none', fontWeight: 750 }}
                >
                  Save & Edit Items
                </LoadingButton>
            </DialogActions>
          </Form>
        </FormikProvider>
        <Toaster position="top-right" />
      </Dialog>
      <UpdatePackageItem
        open={UpdateItemModal}
        handleClose={() => setUpdateItemModal(false)}
        packageData={packageData}
        retrieveService={retrieveService}
        selectedPackageData={selectedPackageData}
      />
    </>
  );
}

export default UpdatePackageModal;
